import { Component, Input } from '@angular/core';
import { IOrder } from '../../model/models/order/order-interface';
import { OrderMapper } from '../../providers/order/order.mapper';
import { OrderStatusEntityType } from '../../model/types/order-status-entity-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-transfer-details',
  templateUrl: 'rmt-transfer-details.html'
})
export class RmtTransferDetailsComponent {
  @Input('order') order: IOrder;
  @Input() titleId:string;
  text: string;
  status: string;
  statusOk: boolean = true;
  numberToDisplay: string;
  textToDisplay: string;

  constructor(private translate: TranslateService) {
  }

  ngAfterViewInit() {
    let statusType;

    this.numberToDisplay = this.order.pin ? this.order.pin : this.order.orderNumber ? this.order.orderNumber : this.order.number;
    if (this.order.pin)
      this.textToDisplay = this.translate.instant('page.trackTransferPage.trackTransferPIN');
    else
      this.textToDisplay = this.translate.instant('page.trackTransferPage.trackTransferOrderNumber');

    if (this.order.shownOrderStatus) {
      this.status = this.order.shownOrderStatus;
      statusType = this.order.orderStatus;
    }
    else {      
      const status = OrderMapper.mapOrderStatus(<OrderStatusEntityType>this.order.status)
      this.status = OrderMapper.mapOrderStatusText(status);
      statusType = this.order.status;
    }

    if (statusType === OrderStatusEntityType.Canceled || statusType === OrderStatusEntityType.ConfirmationExpired) {
      this.statusOk = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-transfer-details/rmt-transfer-details.ts